export default function ({store, params}) {
  if (params.uuid === '_') {
    store.commit('SET_NEW', true)
  } else {
    store.commit('SET_NEW', false)
  }
}
